import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import {
  DatePicker,
  DesktopTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { useFormik } from "formik";
import * as Yup from "yup";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Close, Delete, Edit } from "@mui/icons-material";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import { AuthContext } from "../../../../context/AuthContext";
import { LoadingButton } from "@mui/lab";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const AddRFLTaskDialog = ({
  dialogData,
  handleClose,
  handleSubmit,
  errorMessage,
  loading,
}) => {
  const theme = useTheme();
  const { authToken, ezorder, decoded } = useContext(AuthContext);
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const validationSchema = Yup.object({
    // eventEntity: Yup.mixed()
    //   .oneOf(["IND", "RFL"], "Entity required")
    //   .required("Entity required"),
    // date: Yup.mixed().test(
    //   "is-valid-date",
    //   "Please select a valid date",
    //   (value) => dayjs.isDayjs(value) && value.isValid()
    // ),
    // startDate: Yup.mixed().test(
    //   "is-valid-date",
    //   "Please select a valid start time",
    //   (value) => dayjs.isDayjs(value) && value.isValid()
    // ),
    // endDate: Yup.mixed().test(
    //   "is-valid-date",
    //   "Please select a valid stop time",
    //   (value) => dayjs.isDayjs(value) && value.isValid()
    // ),
    // order: Yup.object()
    //   .nullable()
    //   .when("eventEntity", {
    //     is: "IND", // alternatively: (val) => val == true
    //     then: Yup.object()
    //       .nullable()
    //       .shape({
    //         id: Yup.number().required("Select an Industry Job"),
    //       })
    //       .required("Select an Industry Job"),
    //     otherwise: Yup.object().nullable(),
    //   }),
    transactionId: Yup.number("Select a mfg")
      .nullable()
      .when("eventEntity", {
        is: "RFL", // alternatively: (val) => val == true
        then: Yup.number().nullable().required("Select an RFL Job"),
        otherwise: Yup.number().nullable(),
      }),

    // assignedTo: Yup.array().of(
    //   Yup.object().shape({
    //     id: Yup.number(),
    //   })
    // ),
    // // .min(1, `Assign at least one person`),
    // subPhases: Yup.array().of(
    //   Yup.object().shape({
    //     id: Yup.number(),
    //   })
    // ),
  });

  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: true,
    initialValues: {
      transactionId:
        dialogData && dialogData.transaction ? dialogData.transaction.id : null,
      name:
        dialogData && dialogData.transaction
          ? dialogData.transaction.item.type.name
          : "",
      process:
        dialogData && dialogData.transaction
          ? dialogData.transaction.manufacturingProcessName
          : "",
      materials:
        dialogData &&
        dialogData.transaction &&
        dialogData.transaction.materialProcessingTransactions
          ? dialogData.transaction.materialProcessingTransactions.map(
              (materialTransaction) => {
                return {
                  name: materialTransaction.item.type.name,
                  transactionId: materialTransaction.id,
                  uom: "pc.",
                  quantityLost: 0,
                };
              }
            )
          : [],
      workStationType:
        dialogData && dialogData.transaction
          ? dialogData.transaction.workStationType
          : "",
      isComplete: false,
      progress: 0,
      goal:
        dialogData && dialogData.transaction
          ? dialogData && dialogData.transaction.manufacturingGoal
          : 0,
      uom: "pc.",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      // Submit
      console.log("SUBMIT", values);
      handleSubmit(dialogData.transaction.id, values);
    },
  });

  useEffect(() => {
    console.log("values", formik.values);
  }, [formik.values]);

  if (formik && formik.values && dialogData && dialogData.transaction)
    return (
      <Dialog
        open={dialogData.open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth={true}
      >
        <>
          {dialogData.transaction && (
            <DialogTitle sx={{ display: "flex", flexDirection: "row" }}>
              <Typography
                sx={{
                  flex: 1,
                  fontFamily: "inherit",
                  fontWeight: "inherit",
                  fontSize: "inherit",
                }}
              >
                Add New Task
              </Typography>

              <Box>
                <IconButton onClick={handleClose} sx={{}}>
                  <Close />
                </IconButton>
              </Box>
            </DialogTitle>
          )}

          {dialogData.transaction && (
            <DialogContent>
              <TextField
                disabled={true}
                size="small"
                fullWidth
                sx={{ marginTop: "8px" }}
                label="Name"
                id="name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.name && Boolean(formik.errors.name)}
                helperText={formik.errors.name && `${formik.errors.name}`}
                onFocus={(e) => {
                  e.target.select();
                }}
              />
              <TextField
                disabled={true}
                size="small"
                fullWidth
                sx={{ marginTop: "8px" }}
                label="Process"
                id="process"
                name="process"
                value={formik.values.process}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.process && Boolean(formik.errors.process)}
                helperText={formik.errors.process && `${formik.errors.process}`}
                onFocus={(e) => {
                  e.target.select();
                }}
              />
              <TextField
                type="number"
                inputProps={{
                  min: 0,
                  max: dialogData.transaction.manufacturingGoal,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" sx={{ marginLeft: "4px" }}>
                      {dialogData.transaction.manufacturingGoal}{" "}
                      {formik.values.uom} max
                    </InputAdornment>
                  ),
                }}
                size="small"
                fullWidth
                sx={{ marginTop: "8px" }}
                label="Goal"
                id="goal"
                name="goal"
                value={formik.values.goal}
                onChange={(e) => {
                  let val = e.target.value;
                  if (
                    Number(val ?? 0) <= dialogData.transaction.manufacturingGoal
                  ) {
                    formik.setFieldValue("goal", val);
                  }
                }}
                onBlur={formik.handleBlur}
                error={formik.touched.goal && Boolean(formik.errors.goal)}
                helperText={formik.errors.goal && `${formik.errors.goal}`}
                onFocus={(e) => {
                  e.target.select();
                }}
              />
              <Box sx={{ marginTop: "8px" }}>
                <Typography sx={{ fontWeight: "bold" }}>Materials</Typography>
                {formik.values.materials &&
                  formik.values.materials.map((material, index) => {
                    return <Typography key={index}>{material.name}</Typography>;
                  })}
              </Box>

              <Box>
                {errorMessage && (
                  <Box>
                    <Typography color={"red"}>{errorMessage}</Typography>
                  </Box>
                )}
              </Box>
            </DialogContent>
          )}

          <DialogActions>
            <LoadingButton
              loading={loading}
              onClick={() => {
                formik.handleSubmit();
              }}
            >
              Save
            </LoadingButton>
          </DialogActions>
        </>
      </Dialog>
    );
};

export default AddRFLTaskDialog;
